import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import './index.css';

const b = cn('logo-print');

class LogoPrint extends Component {
    static contextType = LangContext;

    render() {
        const { dictionary } = this.context;

        return (
            <div className={b('')}>
                <img
                    src={`https://yastatic.net/q/logoaas/v2/${dictionary.yandex}.png?size=35`}
                    alt={dictionary.yandex}
                    />
            </div>
        );
    }
}

export default LogoPrint;
